import * as Yup from 'yup'

import { EMPTY_OBJECT } from '../../../constants/common'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
  isRemoveAllEntityActionType,
} from '../../Entity'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../Formik'

import {
  TASK_EDIT_PRIORITY_FIELDS_FIELD_NAME,
  TASK_EDIT_PRIORITY_FIELDS_INITIAL_VALUES,
  TASK_EDIT_PRIORITY_FORM_ACTION_TYPES,
} from './TaskEditPriorityModal.constants'

export function getTaskEditPriorityActionTypes(
  availableTypes = TASK_EDIT_PRIORITY_FORM_ACTION_TYPES
) {
  return Object.values(getEntityActionTypeSelectOptions()).filter(item =>
    availableTypes.includes(item.value)
  )
}

export function getTaskEditPriorityInitialValues() {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    ...TASK_EDIT_PRIORITY_FIELDS_INITIAL_VALUES,
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]:
      actionTypeOptions[EntityActionTypeSelectOptionValue.Edit],
  }
}

export function getTaskEditPriorityPayload(values) {
  const payload = values[TASK_EDIT_PRIORITY_FIELDS_FIELD_NAME]?.value
    ? {
        [TASK_EDIT_PRIORITY_FIELDS_FIELD_NAME]:
          values[TASK_EDIT_PRIORITY_FIELDS_FIELD_NAME].value,
      }
    : EMPTY_OBJECT

  return payload
}

export function getTaskEditPriorityValidationSchema() {
  return Yup.object({
    [TASK_EDIT_PRIORITY_FIELDS_FIELD_NAME]: Yup.object()
      .nullable()
      .when(FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME, {
        is: actionType => !isRemoveAllEntityActionType(actionType),
        then: schema => schema.required(true),
      }),
  })
}
